
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.34884 20.95H14.6512C16.7884 20.95 17.8938 20.435 18.5263 19.7193C19.2057 18.9504 19.7 17.5531 19.7 15V9C19.7 6.4469 19.2057 5.04956 18.5263 4.28071C17.8938 3.56501 16.7884 3.05 14.6512 3.05H9.34884C7.21156 3.05 6.10621 3.56501 5.47373 4.28071C4.79429 5.04956 4.3 6.4469 4.3 9V15C4.3 17.5531 4.79429 18.9504 5.47373 19.7193C6.10621 20.435 7.21156 20.95 9.34884 20.95ZM9.34884 22.75H14.6512C19.4498 22.75 21.5 20.43 21.5 15V9C21.5 3.57 19.4498 1.25 14.6512 1.25H9.34884C4.55023 1.25 2.5 3.57 2.5 9V15C2.5 20.43 4.55023 22.75 9.34884 22.75Z","fill":"#16171F"}}),_c('path',{attrs:{"d":"M14.6512 22.75H9.34884C4.55023 22.75 2.5 20.43 2.5 15V9C2.5 3.57 4.55023 1.25 9.34884 1.25H14.6512C19.4498 1.25 21.5 3.57 21.5 9V15C21.5 20.43 19.4498 22.75 14.6512 22.75Z","fill":"#5D5CFD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.84998 6.99998C6.84998 6.50292 7.25292 6.09998 7.74998 6.09998H15.25C15.747 6.09998 16.15 6.50292 16.15 6.99998C16.15 7.49703 15.747 7.89998 15.25 7.89998H7.74998C7.25292 7.89998 6.84998 7.49703 6.84998 6.99998ZM6.84998 12C6.84998 11.5029 7.25292 11.1 7.74998 11.1H16.25C16.747 11.1 17.15 11.5029 17.15 12C17.15 12.497 16.747 12.9 16.25 12.9H7.74998C7.25292 12.9 6.84998 12.497 6.84998 12ZM7.74998 16.1C7.25292 16.1 6.84998 16.5029 6.84998 17C6.84998 17.497 7.25292 17.9 7.74998 17.9H13.25C13.747 17.9 14.15 17.497 14.15 17C14.15 16.5029 13.747 16.1 13.25 16.1H7.74998Z","fill":"white"}})])
          )
        }
      }
    